import { Component, OnInit } from '@angular/core';
import { GroupsModel } from 'src/app/models/GroupsModel';
import { GroupsService } from 'src/app/services/GroupsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { UserPermService } from 'src/app/services/UserPermService';
import { UserPermModel } from 'src/app/models/UserPermModel';
import {formatDate} from '@angular/common';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-user-perm',
  templateUrl: './user-perm.component.html',
  styleUrls: ['./user-perm.component.css']
})
export class UserPermComponent implements OnInit {

  userID ='';
  userName = '';


  usGroup ='';
  usAdmin = '';
  usStaff =  '';
  usOncologist = '';
  usPharma =  '';
  usAccounting = '';
  userID1 = '';
  modifiedDate = '2021-01-01';
  compCode = '1';

  groupsList: GroupsModel[] =[];


  constructor(public groupsService: GroupsService,
              public userPerm: UserPermService,
              public group: UserPermModel,
              public storage: LocalStorageService) { }

  ngOnInit(): void {
    this.retriveGroupsLookupTop();
  }
  retriveGroupsLookupTop() {
    this.groupsService
      .getGroupsLookupTop(this.compCode)
      .subscribe((data: GroupsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.groupsList[i] = data[i];
        }
        console.log(data);
      });
  }


  retriveUserPerm(){
    this.userPerm.getUserPermission(this.userID,this.storage.retrieve('stgcompCode')).subscribe((data: UserPermModel) => {

      this.usAdmin = data.usAdmin;
      this.usStaff = data.usStaff;
      this.usOncologist = data.usOncologist;
      this.usPharma = data.usPharma;
      this.usAccounting = data.usAccounting;
      this.compCode = data.compCode;
      this.userID1 = data.userID;
      this.modifiedDate = data.modifiedDate;
      console.log(data);
    }
    );
  }

  submitUserPerm() {
    this.group.usGroup = this.userID;
    this.group.usAdmin = this.usAdmin;
    this.group.usStaff = this.usStaff;
    this.group.usOncologist = this.usOncologist;
    this.group.usPharma = this.usPharma;
    this.group.usAccounting = this.usAccounting;

    this.group.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.group.compCode = this.storage.retrieve('stgcompCode');
    this.group.userID = this.storage.retrieve('stguserId');
    this.userPerm.AddUserPermission(this.group).subscribe(data => {
      console.log(data.usGroup);
      console.log(data.compCode);
      this.mesgSave();
    },

      error => { alert(error); }

    );

  }
  NewData() {
    this.usGroup = '';
    this.userID = '';

    this.usAdmin = '';
    this.usAdmin = '';
    this.usStaff ='';
    this.usOncologist = '';
    this.usPharma ='';
    this.usAccounting = '';
    this.compCode = this.storage.retrieve('stgcompCode');
    this.userID1 = this.storage.retrieve('stguserId');
    this.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',
    
    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }
}
